module.exports = __webpack_public_path__ + "media/icons/load-more-cars-arrow@3x-662976da.svg";